import React from 'react';
import { apiDocStyles } from '../styles/apiDocStyles';

const MethodBadge = ({ method }) => {
  return (
    <span style={apiDocStyles.methodBadge(method)}>
      {method}
    </span>
  );
};

export default MethodBadge;
